// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4g-1";
export var standaloneTable = "_4g-0";